//HANDLE SERVICE BOX

var closeServiceModal = function () {

    var serviceModal = $('.service-book-modal'),
        boxOuter = serviceModal.find('.service-box-outer');

    boxOuter.removeClass('reveal').one(transitionEvent, function (e) {

        serviceModal.removeClass('reveal');

        $('body').removeClass('fixed');

        setTimeout(function () {

            serviceModal.remove();

        }, 300);

    });
};

$('body').on('click', 'a[data-service-modal]', function (e) {

    e.preventDefault();

    var btn = $(this),
        serviceID = btn.data('service-modal');

    btn.addClass('loading filled-white--no-hover');

    pd = new FormData();
    pd.append('action', 're_get_one_time_service_modal');
    pd.append('service', serviceID);

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            if(response.success){

                //ADD HTML AFTER <main> TAG

                $('main').after(response.data);

                setTimeout(function () {

                    $('body').addClass('fixed');

                    //REVEAL MODAL

                    var serviceModal = $('.service-book-modal'),
                        boxOuter = serviceModal.find('.service-box-outer');

                    serviceModal.addClass('reveal').one(transitionEvent, function (e) {
                        boxOuter.addClass('reveal');
                    });

                    //INIT SELECT2

                    serviceModal.find('select').select2({
                        width: '100%',
                        minimumResultsForSearch: -1
                    });

                    //ON DROPDOWN OPEN INIT OVERLAY SCROLL

                    var serviceModalSelect;

                    serviceModal.find('select').on('select2:open', function (e) {

                        setTimeout(function () {

                            var selectOptions = $('.select2-results__options');

                            if(selectOptions.find('.select2-results__option').length > 5) {

                                selectOptions.addClass('fixed-height');

                                serviceModalSelect = selectOptions.overlayScrollbars({
                                    sizeAutoCapable: false
                                }).overlayScrollbars();
                            }

                        }, 100)

                    });

                    serviceModal.find('select').on('select2:closing', function (e) {

                        if(typeof serviceModalSelect !== "undefined"){
                            serviceModalSelect.destroy();
                        }

                    });

                    var datepickerTemplate = '';

                    // datepickerTemplate += '<div class="datepicker-container-wrap">';
                    datepickerTemplate += '<div class="datepicker-container datepicker-one-time-service">';
                    datepickerTemplate += '<div class="datepicker-panel" data-view="days picker">';
                    datepickerTemplate += '<ul data-view="months-selector">';
                    datepickerTemplate += '<li data-view="month prev"></li>';
                    datepickerTemplate += '<li data-view="month current"></li>';
                    datepickerTemplate += '<li data-view="month next"></li>';
                    datepickerTemplate += '</ul>';
                    datepickerTemplate += '<ul data-view="week"></ul>';
                    datepickerTemplate += '<ul data-view="days"></ul>';
                    datepickerTemplate += '</div>';
                    datepickerTemplate += '</div>';
                    // datepickerTemplate += '</div>';

                    var dateInputs = serviceModal.find('input[name="service_activation_date"]');

                    if(dateInputs.length > 0) {

                        dateInputs.datepicker({
                            startDate: datepicker.start,
                            endDate: datepicker.end,
                            date: datepicker.selected,
                            language: 'lt-LT',
                            autoHide: true,
                            trigger: 'input[name="service_activation_date"]',
                            template: datepickerTemplate,
                            zIndex: 1200,
                            offset: -300,
                            filter: function(date, view) {

                                var today = date;
                                var tomorrow = new Date(today);

                                tomorrow.setDate(today.getDate()+1);

                                var ISO = tomorrow.toISOString().split('T')[0];

                                if (availableDates.indexOf(ISO) < 0 && view === 'day') {

                                    return false;

                                }

                            }
                        }).on('change', function (e) {

                            var val = $.trim($(this).val());

                            if(val !== ''){

                                var timeSelector = serviceModal.find('select[name=service_activation_time]');

                                timeSelector.empty().trigger('change');

                                if(availableDatesWithTime[val].length > 0) {

                                    var items = availableDatesWithTime[val];

                                    for(var a=0; a<items.length; a++){

                                        var item = items[a],
                                            timeRange = item.split(' - '),
                                            start = timeRange[0].split(':'),
                                            end = timeRange[1].split(':');

                                        var newOption = new Option(start[0] +':'+ start[1] +' - '+ end[0] +':'+ end[1], item, false, false);

                                        timeSelector.append(newOption);

                                    }

                                    timeSelector.trigger('change').closest('.selector').removeClass('hidden');

                                }

                            }

                        }).on('click', function () {

                            // $(this).datepicker('show');

                        });

                    }

                }, 100)

            }

            btn.removeClass('loading filled-white--no-hover');

        }
    });



});

$('body').on('click', '.service-book-modal .service-box-close', function () {

    closeServiceModal();

});

$('body').on('click', '.service-book-modal', function (e) {

    if($(e.target).closest('.service-box').length <= 0) {

        closeServiceModal();

    }

});

$(document).on('submit', '.service-book-modal form[name="init-service-reservation"]' ,function (e) {

    e.preventDefault();

    var form = $(this);

    form.addClass('loading');

    pd = new FormData();
    pd.append('action', 're_init_one_time_service_reservation');
    pd.append('data', form.serialize());

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            if(response.success){

                // if(response.data.redirect) {
                //
                //     window.location.href = response.data.redirectUrl;
                //
                // }

                var formWrap = form.closest('.form-wrap');

                formWrap.css('height', form.innerHeight()).css('height', 0).one(transitionEvent, function () {

                    formWrap.html(response.data.html);

                    formWrap.css('height', formWrap.find('form').innerHeight()).one(transitionEvent, function () {

                        setTimeout(function () {
                            formWrap.removeAttr('style');
                        }, 300);

                    });

                });

            }else {

                var data = response.data;

                for(var a=0; a<data.length; a++) {

                    form.find('*[name='+ data[a]['input']+']').closest('.selector').addClass('error').find('.error-explain').text(data[a]['message']);

                }

                form.removeClass('loading');
            }

        }
    });


});

$(document).on('submit', '.service-book-modal form[name="init-service-reservation-payment"]' ,function (e) {

    e.preventDefault();

    var form = $(this);

    form.addClass('loading');

    pd = new FormData();
    pd.append('action', 're_init_one_time_service_reservation_payment');
    pd.append('data', form.serialize());

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            if(response.success){

                if(response.data.redirect) {

                    window.location.href = response.data.redirectUrl;

                }

            }else {

                form.removeClass('loading');

                var formWrap = form.closest('.form-wrap');

                for(var a=0; a<response.data.length; a++) {

                    var error = response.data[0];

                    if(error.type === 'reservation') {

                        formWrap.css('height', form.innerHeight()).css('height', 0).one(transitionEvent, function () {

                            formWrap.html('<div class="big-error">Apgailėstaujame tačiau šis laikas yra rezervuotas.</div>');

                            formWrap.css('height', formWrap.find('.big-error').innerHeight()).one(transitionEvent, function () {

                                setTimeout(function () {
                                    formWrap.removeAttr('style');
                                }, 300);

                            });

                        });

                        break;

                    }

                }

            }

        }
    });


});

$(document).on('change', '.service-book-modal form input, .service-book-modal form select', function (e) {

    $('.service-book-modal form .selector.error').removeClass('error').find('.error-explain').text('');

});